/* "View all" cute tow-car — auto-applies to every section head that has a
   "View all" link. The car idles, revs, then yanks the badge toward it on a
   loop. Markup is built here so no per-section template edits are needed.
   Falls back to the plain link when there's no room / on small screens /
   under reduced motion, and only animates while the head is on screen. */
(function () {
  var GID = 0;

  function carSVG() {
    return '<svg viewBox="0 0 120 74" aria-hidden="true">' +
      '<ellipse cx="60" cy="68" rx="48" ry="4.5" fill="rgba(0,0,0,.14)"/>' +
      '<g class="viewall-tow__parcel">' +
        '<rect x="23" y="4" width="23" height="15" rx="2.5" fill="#f59e0b" stroke="#1e293b" stroke-width="1.6"/>' +
        '<path d="M34.5 4v15M23 11.5h23" stroke="#b45309" stroke-width="1.8"/>' +
        '<rect x="31.5" y="1" width="6" height="3" rx="1" fill="#fbbf24" stroke="#1e293b" stroke-width="1"/>' +
      '</g>' +
      '<path d="M11 16 C11 13 13 11 16 11 L69 11 C72 11 74 13 74 16 L74 53 C74 54.5 72.5 55 70.5 55 L14.5 55 C12.5 55 11 54 11 52 Z" fill="#ffffff" stroke="#1e293b" stroke-width="2.4" stroke-linejoin="round"/>' +
      '<path d="M11.5 33 L73.5 33" stroke="#2454ff" stroke-width="4.5"/>' +
      '<line x1="18" y1="12" x2="18" y2="54" stroke="#e2e8f0" stroke-width="1.4"/>' +
      '<line x1="42" y1="12" x2="42" y2="54" stroke="#e2e8f0" stroke-width="1.2"/>' +
      '<path d="M74 20 L86 20 C91 20 95 23 98 28 L105 38 C108 41 110 44 111 47 L111 52 C111 54 109 55 107 55 L74 55 Z" fill="#ffffff" stroke="#1e293b" stroke-width="2.4" stroke-linejoin="round"/>' +
      '<path d="M76 23 L85 23 C88 23 91 25 93 28 L98 37 L76 37 Z" fill="#38bdf8" stroke="#1e293b" stroke-width="1.8" stroke-linejoin="round"/>' +
      '<line x1="80" y1="25" x2="88" y2="35" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" opacity=".85"/>' +
      '<line x1="74" y1="37" x2="74" y2="54" stroke="#cbd5e1" stroke-width="1.4"/>' +
      '<rect x="78" y="42" width="5" height="2" rx="1" fill="#94a3b8"/>' +
      '<rect class="viewall-tow__headlight" x="107" y="43" width="5" height="6" rx="1.5" fill="#fbbf24" stroke="#1e293b" stroke-width="1.4"/>' +
      '<rect x="107" y="50" width="5.5" height="4" rx="1" fill="#64748b" stroke="#1e293b" stroke-width="1.2"/>' +
      '<rect x="9.5" y="43" width="3" height="6" rx="1" fill="#ef4444" stroke="#1e293b" stroke-width="1.2"/>' +
      '<rect x="7" y="48" width="5" height="5" rx="1" fill="#64748b" stroke="#1e293b" stroke-width="1.2"/>' +
      '<circle cx="7.5" cy="50" r="3" fill="#ffffff" stroke="#1e293b" stroke-width="1.8"/>' +
      '<path d="M17 55 A13 13 0 0 1 41 55" fill="#1e293b" opacity=".12"/>' +
      '<path d="M78 55 A13 13 0 0 1 102 55" fill="#1e293b" opacity=".12"/>' +
      '<g class="viewall-tow__wheel">' +
        '<circle cx="29" cy="55" r="11" fill="#1e293b"/>' +
        '<circle cx="29" cy="55" r="6" fill="#e2e8f0" stroke="#1e293b" stroke-width="1.2"/>' +
        '<circle cx="29" cy="55" r="2.2" fill="#1e293b"/>' +
        '<line x1="29" y1="50" x2="29" y2="60" stroke="#94a3b8" stroke-width="1.2"/>' +
        '<line x1="24" y1="55" x2="34" y2="55" stroke="#94a3b8" stroke-width="1.2"/>' +
      '</g>' +
      '<g class="viewall-tow__wheel">' +
        '<circle cx="90" cy="55" r="11" fill="#1e293b"/>' +
        '<circle cx="90" cy="55" r="6" fill="#e2e8f0" stroke="#1e293b" stroke-width="1.2"/>' +
        '<circle cx="90" cy="55" r="2.2" fill="#1e293b"/>' +
        '<line x1="90" y1="50" x2="90" y2="60" stroke="#94a3b8" stroke-width="1.2"/>' +
        '<line x1="85" y1="55" x2="95" y2="55" stroke="#94a3b8" stroke-width="1.2"/>' +
      '</g>' +
      '</svg>';
  }

  function enhance(head) {
    if (head.dataset.towReady === '1') return;
    var plain = head.querySelector('.section-head__link');
    if (!plain) return;
    head.dataset.towReady = '1';
    head.classList.add('section-head--tow');
    plain.classList.add('viewall-tow__plain');

    var label = (plain.textContent || 'View All').replace(/\s+/g, ' ').trim() || 'View All';

    var stage = document.createElement('div');
    stage.className = 'viewall-tow';
    stage.innerHTML =
      '<svg class="viewall-tow__rope" aria-hidden="true"><path class="viewall-tow__rope-sh"></path><path class="viewall-tow__rope-mn"></path><path class="viewall-tow__rope-hi"></path></svg>' +
      '<div class="viewall-tow__car">' + carSVG() + '</div>';

    var badge = document.createElement('a');
    badge.className = 'viewall-tow__badge';
    badge.setAttribute('href', plain.getAttribute('href') || '#');
    badge.innerHTML = '<span></span><span aria-hidden="true">&rarr;</span>';
    badge.firstChild.textContent = label;
    // rope is first (paints behind), then badge, then car on top
    stage.insertBefore(badge, stage.lastChild);

    head.appendChild(stage);
    animate(head, stage, badge);
  }

  function animate(head, stage, badge) {
    var title = head.querySelector('.section-head__title');
    var car = stage.querySelector('.viewall-tow__car');
    var wheels = car.querySelectorAll('.viewall-tow__wheel');
    var ropeSh = stage.querySelector('.viewall-tow__rope-sh');
    var ropeMn = stage.querySelector('.viewall-tow__rope-mn');
    var ropeHi = stage.querySelector('.viewall-tow__rope-hi');

    var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
    var lerp = function (a, b, t) { return a + (b - a) * t; };

    var CARW = window.innerWidth < 768 ? 56 : 68, scale = CARW / 120;
    var hookLX = 8 * scale, hookLY = 50 * scale;     // rear-left hook (local)

    // timing
    var IDLE = 5.2, REV = 0.9, YANK = 0.36, REC = 2.3, GAG = REV + YANK + REC, CYCLE = IDLE + GAG;
    var PULL = 46;                                     // how far the badge gets yanked

    var raf = null, started = 0, blinkTimer = null, running = false;
    var bx = 0, bv = 0, K = 150, C = 7;                // badge spring (offset from home; +right)
    var wheelRot = 0, energy = 0;
    var L = null;

    function layout() {
      var sr = head.getBoundingClientRect();
      var tr = title ? title.getBoundingClientRect() : { right: sr.left };
      var W = head.clientWidth, H = head.clientHeight;
      var bw = badge.offsetWidth, bh = badge.offsetHeight, ch = car.offsetHeight;
      var carLeft = W - CARW - 4;                      // car parked at the right edge
      var badgeHome = carLeft - 30 - bw;               // badge sits just left of the car
      return {
        W: W, H: H, bw: bw, bh: bh, badgeHome: badgeHome, badgeY: (H - bh) / 2,
        carLeft: carLeft, carY: (H - ch) / 2 + 2, titleRight: tr.right - sr.left
      };
    }

    // dust pool
    var puffs = [];
    function makePuffs() {
      for (var i = 0; i < 16; i++) {
        var d = document.createElement('div');
        d.className = 'viewall-tow__puff';
        stage.appendChild(d);
        puffs.push({ el: d, a: false, x: 0, y: 0, vx: 0, vy: 0, t: 0, max: 0, s: 0 });
      }
    }
    function spawn(x, y, n) {
      for (var k = 0; k < n; k++) {
        var p = null;
        for (var i = 0; i < puffs.length; i++) { if (!puffs[i].a) { p = puffs[i]; break; } }
        if (!p) return;
        p.a = true; p.x = x + (Math.random() * 8 - 4); p.y = y + (Math.random() * 4 - 2);
        p.vx = -(0.6 + Math.random() * 1.2); p.vy = -(0.4 + Math.random() * 0.9);
        p.t = 0; p.max = 26 + Math.random() * 16; p.s = 0.5 + Math.random() * 0.4;
      }
    }
    function stepPuffs() {
      for (var i = 0; i < puffs.length; i++) {
        var p = puffs[i]; if (!p.a) continue;
        p.t++; p.x += p.vx; p.y += p.vy; p.vy += 0.012; p.vx *= 0.97;
        var k = p.t / p.max;
        if (k >= 1) { p.a = false; p.el.style.opacity = 0; continue; }
        var sc = p.s * (0.6 + k * 1.8), op = (1 - k) * 0.65;
        p.el.style.opacity = op;
        p.el.style.transform = 'translate(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px) scale(' + sc.toFixed(2) + ')';
      }
    }

    function drawRope(hx, hy, ax, ay) {
      var dist = Math.hypot(hx - ax, hy - ay), rest = 28;
      var sag = clamp(12 - (dist - rest) * 0.35, 1.5, 16);
      var wob = Math.sin(performance.now() * 0.045) * clamp(Math.abs(bv) * 0.05, 0, 5);
      var w = clamp(3 * (rest / Math.max(dist, 1)), 1.5, 3.4);
      var mx = (hx + ax) / 2, my = (hy + ay) / 2 + sag + wob;
      var d = 'M' + ax.toFixed(1) + ' ' + ay.toFixed(1) + ' Q' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' ' + hx.toFixed(1) + ' ' + hy.toFixed(1);
      ropeSh.setAttribute('d', d); ropeMn.setAttribute('d', d); ropeHi.setAttribute('d', d);
      ropeSh.style.strokeWidth = (w + 1.6); ropeMn.style.strokeWidth = w; ropeHi.style.strokeWidth = Math.max(0.8, w - 1.8);
    }

    function frame(now) {
      if (!running) return;
      var el = (now - started) / 1000;
      var ct = el % CYCLE, gt = ct - IDLE;

      var bob, carRot = 0, carOffX = 0, sqx = 1, sqy = 1, target = 0;

      if (ct < IDLE) {                               // idle: gentle bob
        bob = Math.sin(el * 1.5) * 1.3; energy *= 0.85; target = 0;
      } else if (gt < REV) {                         // anticipation: squat & rev
        var p = gt / REV, e = Math.sin(p * Math.PI);
        bob = Math.sin(el * 11) * 1.2;               // engine shudder
        sqx = 1 + 0.10 * e; sqy = 1 - 0.10 * e; carOffX = -5 * e; carRot = 2.5 * e;
        energy = lerp(energy, 34, 0.25);
        if (Math.random() < 0.5 * p) spawn(L.carLeft + 30 * scale, L.carY + 62 * scale, 1);
        target = 0;
      } else if (gt < REV + YANK) {                  // YANK!
        var q = (gt - REV) / YANK, e2 = Math.sin(q * Math.PI);
        bob = -2 * e2; carRot = -12 * e2; carOffX = 9 * e2; sqx = 1 + 0.14 * e2; sqy = 1 - 0.10 * e2;
        energy = 44;
        target = PULL;                               // drag badge right toward car
        if (q < 0.25) spawn(L.carLeft + 30 * scale, L.carY + 62 * scale, 3);
      } else {                                       // recover + boing
        var r = (gt - REV - YANK) / REC;
        var bounce = Math.exp(-7 * r) * Math.cos(22 * r);
        carRot = -9 * bounce * (1 - r); carOffX = 7 * bounce * (1 - r);
        sqx = 1 + 0.10 * bounce * (1 - r); sqy = 1 - 0.07 * bounce * (1 - r);
        bob = 2.2 * bounce * (1 - r);
        energy *= 0.82; target = 0;                  // released -> spring boings home
      }

      // badge spring
      bv += (target - bx) * K * 0.008; bv *= Math.exp(-C * 0.008); bx += bv * 0.008;
      var bsx = clamp(1 + bv * 0.0016, 0.9, 1.12), bsy = clamp(1 - Math.abs(bv) * 0.001, 0.9, 1.05);
      var btilt = clamp(bv * 0.02, -5, 5);

      // wheels
      wheelRot += energy * 0.25;
      for (var i = 0; i < wheels.length; i++) wheels[i].style.transform = 'rotate(' + wheelRot + 'deg)';

      // place car & badge
      car.style.left = L.carLeft + 'px'; car.style.top = L.carY + 'px';
      car.style.transform = 'translate(' + carOffX.toFixed(2) + 'px,' + bob.toFixed(2) + 'px) rotate(' + carRot.toFixed(2) + 'deg) scale(' + sqx.toFixed(3) + ',' + sqy.toFixed(3) + ')';
      var bX = L.badgeHome + bx;
      badge.style.left = bX + 'px'; badge.style.top = L.badgeY + 'px';
      badge.style.transform = 'translate(0,0) rotate(' + btilt.toFixed(2) + 'deg) scale(' + bsx.toFixed(3) + ',' + bsy.toFixed(3) + ')';

      // rope: badge right -> car rear hook
      var hx = L.carLeft + carOffX + hookLX, hy = L.carY + bob + hookLY;
      var ax = bX + L.bw + 9, ay = L.badgeY + L.bh / 2;
      drawRope(hx, hy, ax, ay);

      stepPuffs();
      raf = requestAnimationFrame(frame);
    }

    function play() {
      if (running) return;
      head.classList.add('is-on');                   // render the stage so we can measure
      L = layout();
      if (window.innerWidth < 520 ||
          window.matchMedia('(prefers-reduced-motion:reduce)').matches ||
          L.badgeHome < L.titleRight + 16) {
        head.classList.remove('is-on'); return;      // not enough room -> plain link
      }
      if (!puffs.length) makePuffs();
      bx = 0; bv = 0; energy = 0; started = performance.now();
      running = true;
      if (blinkTimer) clearInterval(blinkTimer);
      blinkTimer = setInterval(function () {
        car.classList.add('is-blink');
        setTimeout(function () { car.classList.remove('is-blink'); }, 180);
      }, 3200);
      raf = requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (blinkTimer) { clearInterval(blinkTimer); blinkTimer = null; }
    }

    // only animate while the head is on screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) play(); else stop();
        }
      }, { rootMargin: '120px' });
      io.observe(head);
    } else {
      play();
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        CARW = window.innerWidth < 768 ? 56 : 68; scale = CARW / 120;
        hookLX = 8 * scale; hookLY = 50 * scale;
        stop(); play();
      }, 200);
    });
  }

  function boot(root) {
    var heads = (root || document).querySelectorAll('.section-head');
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].querySelector('.section-head__link')) enhance(heads[i]);
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  // Shopify theme editor: enhance section heads when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
